import { render, staticRenderFns } from "./ImsGroupTable.vue?vue&type=template&id=4e32b13c&scoped=true&"
import script from "./ImsGroupTable.vue?vue&type=script&lang=js&"
export * from "./ImsGroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32b13c",
  null
  
)

export default component.exports